module.exports = __webpack_public_path__ + "img/big6-1.2b711a0d.jpg";